// GĐ4c TRỢ LÝ "TAY trong vòng có rào" — phía WEB (docs/thiet-ke-gd4c-tay.md mục 7). (1) Khung "Đang tự làm" trên trang Trợ lý: mỗi vòng một
// thẻ — trạng thái (lượt n/5), đếm sửa/chạy thử/phút còn lại, tiến độ từng lượt (đã sửa gì → chạy thử → kết quả), nút Dừng, khi xong có nút
// DẪN TỚI trang kịch bản để NGƯỜI bấm Chạy thật. (2) Dải trên trang kịch bản: "Trợ lý đang tự làm (lượt n/5)". Thăm dò 1,5 s khi có vòng đang chạy
// (F5 không mất — trạng thái ở máy chủ). Mọi chữ từ máy chủ dựng bằng textContent.
import { api, errMsg } from "../api";
import { busy, clear, h, toast } from "../dom";
import { fmtTime } from "../format";

interface BuocV { id: number; luot: number; loai: string; noiDung: string; phienBan: number | null; runKey: string | null; taoLuc: string }
export interface VongV {
  id: string; kichBanId: string; kichBanTen: string | null; botId: string; botTen: string | null; mucTieu: string; trangThai: string; tenTrangThai: string;
  giaiDoan: string | null; tenGiaiDoan: string | null; luot: number; soLanSua: number; soLanChay: number; toiDa: { sua: number; chay: number; phut: number };
  conPhut: number | null; ketQua: string | null; batDauLuc: string; hetHanLuc: string; ketThucLuc: string | null; lienKetKichBan: string; dungDuoc: boolean; buoc: BuocV[];
}

const HOI_LAI_MS = 1500;
const TEN_LOAI: Record<string, string> = { chay_thu: "Chạy thử", ket_qua: "Kết quả", quyet_dinh: "Quyết định", sua: "Đã sửa", chan: "Bị chặn", dung: "Kết thúc" };
const lop = (tt: string) => (tt === "dang_chay" ? "running" : tt === "xong" ? "ok" : tt === "da_dung" ? "" : tt === "dung_tai_khoan" ? "err" : "warn");

/** Một thẻ vòng (dùng chung cho trang Trợ lý). `sauDung` gọi sau khi bấm Dừng (tải lại). */
export function veVong(v: VongV, sauDung: () => void, opts: { chiXem?: boolean } = {}): HTMLElement {
  const dang = v.trangThai === "dang_chay";
  const card = h("div", { class: `card vg-the vg-${v.trangThai}`, "data-testid": "vg-the", dataset: { id: v.id, trangThai: v.trangThai } },
    h("div", { class: "row between wrap vg-dau" },
      h("span", { class: `tag ${lop(v.trangThai)}`, "data-testid": "vg-trang-thai" }, v.tenTrangThai),
      h("a", { href: v.lienKetKichBan, class: "vg-kb", "data-testid": "vg-kb", title: "Mở trang kịch bản" }, `Kịch bản «${v.kichBanTen ?? v.kichBanId}»`)),
    h("p", { class: "small muted vg-muc-tieu", "data-testid": "vg-muc-tieu" }, `Bot «${v.botTen ?? v.botId}» · mục tiêu: «${v.mucTieu}» · bắt đầu ${fmtTime(v.batDauLuc)}`),
    h("p", { class: "small vg-dem", "data-testid": "vg-dem" }, `Đã sửa ${v.soLanSua}/${v.toiDa.sua} lượt · đã chạy thử ${v.soLanChay}/${v.toiDa.chay} lần${dang && v.conPhut !== null ? ` · còn ${v.conPhut} phút` : ""} · trợ lý KHÔNG chạy thật`));
  if (dang && v.tenGiaiDoan) card.append(h("p", { class: "vg-giai-doan", "data-testid": "vg-giai-doan" }, v.tenGiaiDoan));
  // Tiến độ theo lượt.
  const nhom = new Map<number, BuocV[]>();
  for (const b of v.buoc) nhom.set(b.luot, [...(nhom.get(b.luot) ?? []), b]);
  const ds = h("ol", { class: "vg-luot-ds", "data-testid": "vg-luot-ds" });
  for (const [luot, bs] of [...nhom].sort((a, b) => a[0] - b[0])) {
    ds.append(h("li", { class: "vg-luot", "data-testid": "vg-luot", dataset: { luot: String(luot) } },
      h("div", { class: "vg-luot-ten small" }, `Lượt ${luot}/${v.toiDa.chay}`),
      // Chữ của từng dòng do máy chủ viết đã tự nói loại ("Kết quả chạy thử lần 1: …", "Bị chặn (…)") — loại chỉ để tô màu + chú thích.
      h("ul", { class: "vg-buoc-ds" }, ...bs.map((b) => h("li", { class: `vg-buoc vg-b-${b.loai}`, "data-testid": "vg-buoc", dataset: { loai: b.loai }, title: TEN_LOAI[b.loai] ?? b.loai }, b.noiDung)))));
  }
  card.append(ds);
  if (!dang && v.ketQua) card.append(h("p", { class: `vg-ket-qua ${v.trangThai === "xong" ? "ok" : v.trangThai === "dung_tai_khoan" ? "err" : ""}`, "data-testid": "vg-ket-qua" }, v.ketQua));
  const nut = h("div", { class: "row wrap vg-nut" });
  if (v.trangThai === "xong") nut.append(h("a", { class: "btn pri", href: v.lienKetKichBan, "data-testid": "vg-mo-kb", title: "Mở trang kịch bản — bạn tự bấm Chạy thật ở đó" }, "Mở kịch bản để bấm Chạy thật"));
  if (dang && v.dungDuoc && !opts.chiXem) {
    const dung = h("button", { type: "button", class: "danger", "data-testid": "vg-dung", title: "Dừng ngay vòng tự làm (huỷ lần chạy thử đang dở)" }, "Dừng");
    dung.addEventListener("click", () => void busy(dung, "Đang dừng…", async () => {
      try { await api("POST", `/api/tro-ly/vong/${encodeURIComponent(v.id)}/dung`, {}); toast("Đã dừng — trợ lý không làm thêm gì", "info"); }
      catch (e) { toast(errMsg(e), "err"); }
      sauDung();
    }));
    nut.append(dung);
  }
  if (nut.childElementCount) card.append(nut);
  return card;
}

/** Khung "Đang tự làm" trên trang Trợ lý. Trả `taiLai` (gọi sau khi bấm thẻ "Tự làm") + `huy`. */
export function taoKhungTuLam(box: HTMLElement, opts: { ownerQ: string; chiXem: boolean }): { taiLai: () => Promise<void>; huy: () => void } {
  let huy = false;
  let hen: number | undefined;
  let items: VongV[] = [];
  const ve = () => {
    clear(box);
    if (!items.length) return;
    box.append(h("div", { class: "vg-khung", "data-testid": "vg-khung" },
      h("h2", { class: "vg-tieu-de" }, items.some((v) => v.trangThai === "dang_chay") ? "Đang tự làm" : "Tự làm gần đây"),
      ...items.map((v) => veVong(v, () => void taiLai(), { chiXem: opts.chiXem }))));
  };
  async function taiLai(): Promise<void> {
    window.clearTimeout(hen);
    if (huy) return;
    try {
      const q = new URLSearchParams({ limit: "3", ...(opts.ownerQ ? { ownerId: opts.ownerQ } : {}) });
      items = (await api<{ items: VongV[] }>("GET", `/api/tro-ly/vong?${q.toString()}`)).items;
      if (huy) return;
      ve();
    } catch { /* mất mạng: giữ khung cũ, nhịp sau thử lại */ }
    if (!huy && items.some((v) => v.trangThai === "dang_chay")) hen = window.setTimeout(() => void taiLai(), HOI_LAI_MS);
  }
  void taiLai();
  return { taiLai, huy: () => { huy = true; window.clearTimeout(hen); } };
}

/** Dải trên trang kịch bản: vòng đang chạy → "Trợ lý đang tự làm (lượt n/5)" + Dừng; vòng vừa xong → một dòng kết quả. `doiSoDo` khi vòng vừa
 * lưu phiên bản mới / kết thúc (trang tải lại sơ đồ). */
export function taoDaiTuLam(box: HTMLElement, kbId: string, doiSoDo: () => void): { huy: () => void } {
  let huy = false;
  let hen: number | undefined;
  let moc = "";
  async function tai(): Promise<void> {
    if (huy) return;
    let v: VongV | undefined;
    try { v = (await api<{ items: VongV[] }>("GET", `/api/tro-ly/vong?kichBanId=${encodeURIComponent(kbId)}&limit=1`)).items[0]; }
    catch { if (!huy) hen = window.setTimeout(() => void tai(), HOI_LAI_MS * 2); return; }
    if (huy) return;
    clear(box);
    if (v) {
      const dang = v.trangThai === "dang_chay";
      const mocMoi = `${v.trangThai}|${v.soLanSua}`;
      if (moc && mocMoi !== moc) doiSoDo();
      moc = mocMoi;
      if (dang) {
        const dung = v.dungDuoc ? h("button", { type: "button", class: "mini danger", "data-testid": "kb-vg-dung", title: "Dừng ngay vòng tự làm" }, "Dừng") : null;
        dung?.addEventListener("click", () => void busy(dung, "Đang dừng…", async () => {
          try { await api("POST", `/api/tro-ly/vong/${encodeURIComponent(v!.id)}/dung`, {}); } catch (e) { toast(errMsg(e), "err"); }
          void tai();
        }));
        box.append(h("div", { class: "info-box vg-dai row between wrap", "data-testid": "kb-vg-dai" },
          h("span", {}, `🤖 Trợ lý đang tự làm (lượt ${v.luot}/${v.toiDa.chay}) — ${v.tenGiaiDoan ?? ""} Đã sửa ${v.soLanSua}/${v.toiDa.sua}, đã chạy thử ${v.soLanChay}/${v.toiDa.chay}.`),
          h("span", { class: "row wrap" }, h("a", { href: "#/tro-ly", class: "btn mini", "data-testid": "kb-vg-xem" }, "Xem tiến độ"), dung)));
      } else if (v.ketThucLuc && Date.now() - Date.parse(v.ketThucLuc) < 24 * 3600_000) {
        box.append(h("div", { class: `${v.trangThai === "xong" ? "ok-box" : "warn-box"} vg-dai`, "data-testid": "kb-vg-dai" },
          `Trợ lý tự làm (${fmtTime(v.ketThucLuc)}): ${v.tenTrangThai}${v.ketQua ? ` — ${v.ketQua}` : ""}`));
      }
      if (dang) hen = window.setTimeout(() => void tai(), HOI_LAI_MS);
    }
  }
  void tai();
  return { huy: () => { huy = true; window.clearTimeout(hen); } };
}
